import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logout from "./Login/Logout";
import { Logindetail } from "../context/Logindetail";
import { Filter } from "react-bootstrap-icons";
import { useRef } from "react";
import { NavLink } from "react-router-dom";

import { FaBuilding, FaListAlt, FaBoxOpen, FaRegHeart, FaStore, FaBriefcase, FaIdCard, FaPalette } from "react-icons/fa";

import { Nav } from "reactstrap";
import DeleteAccount from "./Login/DeleteAccount";

const Dashboard = ({ setting_data }) => {
  const [isloading, setisloading] = useState(false);

  const { detail_info } = useContext(Logindetail);

  // console.log('detail_info',detail_info);

  // console.log('setting',setting_data)

  const [show, setshow] = useState(false);

  const [open, setOpen] = useState(false);
  const [enrollOpen, setEnrollOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleDropdown = () => setOpen((prev) => !prev);
  const toggleEnrollDropdown = () => setEnrollOpen((prev) => !prev);

  const [agentMenuOpen, setAgentMenuOpen] = useState(false);

  const toggleAgentMenu = () => {
    setAgentMenuOpen((prev) => !prev);
  };


  // useEffect(() => {
  //   // const handleClickOutside = (event) => {
  //   //   if (menuRef.current && !menuRef.current.contains(event.target)) {
  //   //     setOpen(false);
  //   //   }
  //   // };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);



  const handleChange = () => {
    setshow(!show);
  };
  return (
    <>
      <section>
        <div className="customer-pages">
          <div className="pc-logo-header text-center mb-4">
            <Link to="/">
              {/* <img
                src="/assets/images/green.png"
                className="mainIcon img-fluid"
                alt="greenheap"
                style={{ maxWidth: "150px" }}
              /> */}
            </Link>
          </div>
          <Link to="/user/dashboard">
            {" "}
            <div className="dashboard-list d-flex align-items-center for gap-3">
              <div className="page-icon">
                <img src="\assets\iocns\home.png" className="img-fluid" />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/dashboard"
                      ? "active"
                      : "inactive"
                  }
                >
                  My Dashboard
                </h4>
              </div>
            </div>{" "}
          </Link>

          <Link to="/user/myprofile">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img src="\assets\iocns\Profile.png" className="img-fluid" />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/myprofile"
                      ? "active"
                      : "inactive"
                  }
                >
                  My Profile {detail_info?.role == 1 ? `` : ""}
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/manufacturer-designs">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <FaPalette style={{ color: "#d4af37", fontSize: "20px" }} />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/manufacturer-designs"
                      ? "active"
                      : "inactive"
                  }
                >
                  Company Designs
                </h4>
              </div>
            </div>
          </Link>


          <div className="dashboard-list d-flex align-items-center gap-3">
            <div className="page-icon">
              <img src="\assets\iocns\voucher_icon.png" className="img-fluid" />
            </div>
            <div className="page-name">
              <Link to="/user/my-vouchers">
                {" "}
                <h4
                  className={
                    window.location.pathname === "/user/my-vouchers"
                      ? "active"
                      : "inactive"
                  }
                >
                  My Gift Vouchers
                </h4>
              </Link>
            </div>
          </div>

          <div className="dashboard-list d-flex align-items-center gap-3">
            <div className="page-icon">
              <img src="\assets\iocns\encash.png" className="img-fluid" />
            </div>
            <div className="page-name">
              <Link to="/user/encashment">
                {" "}
                <h4
                  className={
                    window.location.pathname === "/user/encashment"
                      ? "active"
                      : "inactive"
                  }
                >
                  Encashment Coupon
                </h4>
              </Link>
            </div>
          </div>
          <div className="dashboard-list d-flex align-items-center gap-3">
            <div className="page-icon">
              <img src="\assets\iocns\orders.png" className="img-fluid" />
            </div>
            <div className="page-name">
              <Link to="/user/myorders">
                {" "}
                <h4
                  className={
                    window.location.pathname === "/user/myorders"
                      ? "active"
                      : "inactive"
                  }
                >
                  My Orders
                </h4>
              </Link>
            </div>
          </div>

          {/* {
                      detail_info?.role == 1 && (
                    <Link className="dropdown" > <div className="dashboard-list d-flex align-items-center dropdown-toggle gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <div className="page-icon">
                            <img src="\assets\iocns\Profile.png" className="img-fluid" />
                        </div>
                        <div className="page-name">
                            <h4 className={window.location.pathname === "/user/myprofile" ? "active" : "inactive"}>{detail_info?.role == 1 ? `Agent/Profile` : ''}</h4>
                        </div>
                    </div>

                     <ul className="dropdown-menu">
    <li><a className="dropdown-item" href="#">Action</a></li>
    <li><a className="dropdown-item" href="#">Another action</a></li>
    <li><a className="dropdown-item" href="#">Something else here</a></li>
  </ul>

                    </Link>
                      )
                    } */}

          {/* {detail_info?.role === 1 && (
            <div className="dropdown">
              <div
                className="dashboard-list d-flex align-items-center dropdown-toggle gap-3"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="page-icon">
                  <img
                    src="/assets/iocns/Profile.png"
                    className="img-fluid"
                    alt="Profile"
                  />
                </div>
                <div className="page-name" onClick={handleChange}>
                  <h4
                    className={
                      window.location.pathname === "/user/companyprofile"
                        ? "active"
                        : "inactive"
                    }
                  >
                    Agent / Profile
                  </h4>
                </div>
              </div>

              <ul className="dropdown-menu">
                <li>
                  <Link
                    className="dropdown-item"
                    to="/user/companyprofile"
                    state={{ type: "Company" }}
                  >
                    Manufacturer/Dealers/Agency Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/user/myordersagent"
                    state={{ type: "Company" }}
                  >
                    Orders List
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/user/myordersagent"
                    state={{ type: "Products" }}
                  >
                    Products List
                  </Link>
                </li>
              </ul>
            </div>
          )} */}

          {(detail_info?.role !== 1 && detail_info?.is_franchise !== 1 && detail_info?.franchise_request !== 1) && (
            <div className="agent-dropdown" ref={menuRef}>
              <div
                className="dashboard-list d-flex align-items-center gap-3"
                style={{ cursor: "pointer" }}
              >
                <div className="page-icon" onClick={toggleDropdown}>
                  <img
                    src="\assets\iocns\agent.png"
                    className="img-fluid"
                    alt={
                      Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                        Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                          Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                            "Manufacturer/Dealers/Agency Profile"
                    }
                  />
                </div>

                <div
                  className="page-name"
                  onClick={toggleDropdown}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <h4
                    className={
                      window.location.pathname === "/user/companyprofile"
                        ? "active"
                        : "inactive"
                    }
                    title={
                      Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                        Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                          Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                            "Manufacturer/Dealers/Agency Profile"
                    }
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "185px",
                    }}
                  >
                    {
                      Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                        Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                          Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                            "Manufacturer/Dealers/Agency Profile"
                    }
                  </h4>
                  <span
                    style={{
                      fontSize: "0.7em",
                      userSelect: "none",
                      display: "inline-block",
                      transition: "transform 0.3s ease",
                      transform: open ? "rotate(180deg)" : "rotate(0deg)",
                      marginLeft: 4,
                    }}
                  >
                    ▼
                  </span>
                </div>
              </div>

              <ul
                className={`dropdown-menu-custom ${open ? "open" : ""}`}
                onClick={(e) => e.stopPropagation()}
                style={{
                  maxHeight: open ? "400px" : "0",
                  opacity: open ? 1 : 0,
                  transition: "max-height 0.2s ease, opacity 0.2s ease",
                  overflow: "hidden",
                  padding: open ? "8px 0" : "0",
                  pointerEvents: open ? "auto" : "none",
                  height: open ? "auto" : "0",
                  marginBottom: open ? "10px" : "0",
                  marginLeft: window.innerWidth < 768 ? "0" : "2.5rem",
                }}
              >
                <li className="enroll-dropdown-item">
                  <Link
                    to="/user/companyprofile"
                    state={{ type: "Company" }}
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => {
                      setOpen(false);
                      setEnrollOpen(false);
                    }}
                  >
                    <FaBuilding color="brown" /> {
                      Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                        Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                          Number(detail_info?.user_type) === 3 ? "Dealer Profile" :
                            "Enroll Now"
                    }
                  </Link>
                </li>

                {Number(detail_info?.company) === 1 && (
                  <>
                    <li>
                      <Link
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/user/myordersagent"
                        state={{ type: "Company" }}
                        onClick={() => setOpen(false)} // <--- close dropdown here
                      >
                        <FaListAlt color="brown" /> Orders List
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/user/myordersagent"
                        state={{ type: "Products" }}
                        onClick={() => setOpen(false)} // <--- close dropdown here
                      >
                        <FaBoxOpen color="brown" /> Products List
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}

          {/* 
          {detail_info?.role === 1 && (
            <div className="agent-dropdown" ref={menuRef}>
              {/* <div
                className="dashboard-list d-flex align-items-center gap-3"
                style={{ cursor: "pointer" }}
                onClick={toggleDropdown}
              >
                <div className="page-icon">
                  <img
                    src="/assets/iocns/Profile.png"
                    className="img-fluid"
                    alt="Agent/Profile"
                  />
                </div>

                <div
                  className="page-name"
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <h4
                    className={
                      window.location.pathname === "/user/companyprofile"
                        ? "active"
                        : "inactive"
                    }
                  >
                    Agent / Profile
                  </h4>
                  <span
                    style={{
                      fontSize: "0.7em",
                      userSelect: "none",
                      display: "inline-block",
                      transition: "transform 0.3s ease",
                      transform: open ? "rotate(180deg)" : "rotate(0deg)",
                      marginLeft: 4,
                    }}
                  >
                    ▼
                  </span>
                </div>
              </div> */}

          {/* <div className="dashboard-list d-flex align-items-center gap-3" style={{ cursor: "pointer" }}>
  <div className="page-icon" onClick={toggleDropdown}>
    <img
      src="/assets/iocns/Profile.png"
      className="img-fluid"
      alt="Agent/Profile"
    />
  </div>

  <div
    className="page-name"
    onClick={toggleDropdown}
    style={{ display: "flex", alignItems: "center", gap: "6px" }}
  >
    <h4
      className={
        window.location.pathname === "/user/companyprofile"
          ? "active"
          : "inactive"
      }
    >
      Agent / Profile
    </h4>
    <span
      style={{
        fontSize: "0.7em",
        userSelect: "none",
        display: "inline-block",
        transition: "transform 0.3s ease",
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        marginLeft: 4,
      }}
    >
      ▼
    </span>
  </div>
</div> */}


          {/* Dropdown menu with smooth height animation */}
          {/* <ul
                className={`dropdown-menu-custom ${open ? "open" : ""}`}
                style={{
                  maxHeight: open ? "300px" : "0",
                  opacity: open ? 1 : 0,
                  transition: "max-height 0.2s ease, opacity 0.2s ease",
                  overflow: "hidden",
                  marginLeft: "2.5rem",
                  paddingLeft: open ? "0px" : "0",
                  pointerEvents: open ? "auto" : "none",
                }}
              > */}
          {/* <ul
                className={`dropdown-menu-custom ${open ? "open" : ""}`}
                
                //  onClick={(e) => e.stopPropagation()}
                style={{
                  maxHeight: open ? "300px" : "0",
                  opacity: open ? 1 : 0,
                  transition: "max-height 0.2s ease, opacity 0.2s ease",
                  overflow: "hidden",
                  padding: open ? "8px 0" : "0",
                  pointerEvents: open ? "auto" : "none",
                  height: open ? "auto" : "0",
                  marginBottom: open ? "10px" : "0",
                  marginLeft: window.innerWidth < 768 ? "0" : "2.5rem", // <-- Add this
                }}
              >
                {/* <ul
  className={`dropdown-menu-custom ${open ? "open" : ""}`}
  style={{
    maxHeight: open ? "300px" : "0",
    opacity: open ? 1 : 0,
    transition: "max-height 0.2s ease, opacity 0.2s ease",
    overflow: "hidden",
    marginLeft: "2.5rem",
    padding: open ? "8px 0" : "0",
    pointerEvents: open ? "auto" : "none",
    height: open ? "auto" : "0", // Important!
    marginBottom: open ? "10px" : "0", // Prevent extra space below
  }}
> */}

          {/* <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2"
                    to="/user/companyprofile"

                    state={{ type: "Company" }}
                  >
                    <FaBuilding color="brown" /> Manufacturer/Dealers/Agency Profile
                  </Link>
                </li>

                <li>


                  <Link
                    className="dropdown-item d-flex align-items-center gap-2"
                    to="/user/myordersagent"
                    state={{ type: "Company" }}
                  >
                    <FaListAlt color="brown" /> Orders List
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2"
                    to="/user/myordersagent"
                    state={{ type: "Products" }}
                  >
                    <FaBoxOpen color="brown" /> Products List
                  </Link>
                </li> */}
          {/* </ul>
            </div>
          )}
 */}



          {detail_info?.role == 1 ? (
            <Link to="/user/commission">
              {" "}
              <div className="dashboard-list d-flex align-items-center gap-3">
                <div className="page-icon">
                  <img src="\assets\iocns\payOut.png" className="img-fluid" />
                </div>
                <div className="page-name">
                  <h4
                    className={
                      window.location.pathname === "/user/commission"
                        ? "active"
                        : "inactive"
                    }
                  >
                    Commission
                  </h4>
                </div>
              </div>
            </Link>
          ) : (
            ""
          )}

          {(
            <Link to="/user/wallet-history">
              {" "}
              <div className="dashboard-list d-flex align-items-center gap-3">
                <div className="page-icon">
                  <img src="\assets\iocns\walletHistory.png" className="img-fluid" />
                </div>
                <div className="page-name">
                  <h4
                    className={
                      window.location.pathname === "/user/wallet-history"
                        ? "active"
                        : "inactive"
                    }
                  >
                    Wallet History
                  </h4>
                </div>
              </div>
            </Link>
          )}





          {detail_info?.role == 1 ? (
            <Link to="/user/payoutrequest">
              {" "}
              <div className="dashboard-list d-flex align-items-center gap-3">
                <div className="page-icon">
                  <img src="\assets\iocns\commision.png" className="img-fluid" />
                </div>
                <div className="page-name">
                  <h4
                    className={
                      window.location.pathname === "/user/payoutrequest"
                        ? "active"
                        : "inactive"
                    }
                  >
                    Payout Request
                  </h4>
                </div>
              </div>
            </Link>
          ) : (
            ""
          )}

          <Link to="/user/kyc">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img src="\assets\iocns\KYC.png" className="img-fluid" />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/kyc"
                      ? "active"
                      : "inactive"
                  }
                >
                  KYC
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/beneficiaries">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img src="\assets\iocns\SIP.png" className="img-fluid" />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/beneficiaries"
                      ? "active"
                      : "inactive"
                  }
                >
                  Beneficiaries
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/chit-jewels">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\right arrow round.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/chit-jewels"
                      ? "active"
                      : "inactive"
                  }
                >
                  {setting_data ? setting_data[0]?.saving_plan : ""}
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/digital-gold">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\right arrow round.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/digital-gold"
                      ? "active"
                      : "inactive"
                  }
                >
                  {setting_data ? setting_data[0]?.digital_plan : ""}
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/digital-silver">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\right arrow round.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/digital-silver"
                      ? "active"
                      : "inactive"
                  }
                >
                  {setting_data ? setting_data[0]?.digital_silver_plan : ""}
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/gold-plant">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\right arrow round.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/gold-plant"
                      ? "active"
                      : "inactive"
                  }
                >
                  {setting_data ? setting_data[0]?.gold_plant : ""}
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/submit-payment-proof">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\right arrow round.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/submit-payment-proof"
                      ? "active"
                      : "inactive"
                  }
                >
                  Submit Payment Proof
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/Notifycation">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img
                  src="\assets\iocns\notification.png"
                  className="img-fluid"
                />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/Notifycation"
                      ? "active"
                      : "inactive"
                  }
                >
                  Notification
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/wishlist">
            {" "}
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                {/* <img
                  src="\assets\iocns\right arrow round.png" 
                  className="img-fluid"
                /> */}
                <FaRegHeart color="brown" size={20} />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/wishlist"
                      ? "active"
                      : "inactive"
                  }
                >
                  Wishlist
                </h4>
              </div>
            </div>
          </Link>

          <Link to="/user/mybank-account">
            <div className="dashboard-list d-flex align-items-center gap-3">
              <div className="page-icon">
                <img src="\assets\iocns\bank.png" className="img-fluid" />
              </div>
              <div className="page-name">
                <h4
                  className={
                    window.location.pathname === "/user/mybank-account"
                      ? "active"
                      : "inactive"
                  }
                >
                  My Bank Accounts
                </h4>
              </div>
            </div>
          </Link>
          {/* <div
            className="dashboard-list border-0 d-flex align-items-center gap-3"
            data-bs-toggle="modal"
            data-bs-target="#delete_account_modal"
          >
            <div className="page-icon">
              <img src="\assets\iocns\Logout.png" className="img-fluid" />
            </div>
            <div className="page-name">
              <h4 className="">Delete Account</h4>
            </div>
          </div> */}

          <div
            className="dashboard-list border-0 d-flex align-items-center gap-3"
            data-bs-toggle="modal"
            data-bs-target="#logout_modal"
          >
            <div className="page-icon">
              <img src="\assets\iocns\Logout.png" className="img-fluid" />
            </div>
            <div className="page-name">
              <h4 className="active">Logout</h4>
            </div>
          </div>
        </div>

        <div className="mb-pages">
          <button
            className="btn "
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasLeft"
            aria-controls="offcanvasLeft"
          >
            <Filter />
          </button>

          <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="offcanvasLeft"
            aria-labelledby="offcanvasLeftLabel"
          >
            <div className="offcanvas-header">
              <img
                src="/assets/images/green.png"
                className="mainIcon"
                alt="greenheap"
              />
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <div className="filter-pages">
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\home.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/dashboard">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/dashboard"
                            ? "active"
                            : "inactive"
                        }
                      >
                        My Dashboard
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\Profile.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/myprofile">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/myprofile"
                            ? "active"
                            : "inactive"
                        }
                      >
                        My Profile
                      </h4>
                    </Link>
                  </div>
                </div>

                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\voucher_icon.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/my-vouchers">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/my-vouchers"
                            ? "active"
                            : "inactive"
                        }
                      >
                        My Gift Vouchers
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\encash.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/encashment">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/encashment"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Encashment
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\orders.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/myorders"> <h4 className={window.location.pathname === "/user/myorders" ? "active" : "inactive"}>My Orders</h4></Link>
                  </div>
                </div>

                {/* {detail_info?.role === 1 && (
                  <div className="dashboard-list d-flex align-items-center gap-3"> */}
                {/* <div className="page-icon">
                    <img
                      src="\assets\iocns\Profile.png"
                      className="img-fluid"
                    />
                  </div> */}
                {/* <div className="page-name">
                    <Link to="/user/myprofile">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/myprofile"
                            ? "active"
                            : "inactive"
                        }
                      >
                        My Profile
                      </h4>
                    </Link>
                  </div> */}

                {/* {detail_info?.role === 1 && (
                      <div className="dropdown">
                        <div
                          className="dashboard-list d-flex align-items-center dropdown-toggle gap-3"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="page-icon">
                            <img
                              src="/assets/iocns/Profile.png"
                              className="img-fluid"
                              alt="Profile"
                            />
                          </div>
                          <div className="page-name" onClick={handleChange}>
                            <h4
                              className={
                                window.location.pathname ===
                                "/user/companyprofile"
                                  ? "active"
                                  : "inactive"
                              }
                            >
                              Agent / Profile
                            </h4>
                          </div>
                        </div>

                        <ul className="dropdown-menu">
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/user/companyprofile"
                              state={{ type: "Company" }}
                            >
                              Manufacturer/Dealers/Agency Profile
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/user/myordersagent"
                              state={{ type: "Company" }}
                            >
                              Orders List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/user/myordersagent"
                              state={{ type: "Products" }}
                            >
                              Products List
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                )} */}




                {(detail_info?.role !== 1 && detail_info?.is_franchise !== 1 && detail_info?.franchise_request !== 1) && (
                  <div className="agent-dropdown" ref={menuRef}>
                    <div
                      className="dashboard-list d-flex align-items-center gap-3"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="page-icon" onClick={toggleDropdown}>
                        <img
                          src="\assets\iocns\agent.png"
                          className="img-fluid"
                          alt={
                            Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                              Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                                Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                                  "Manufacturer/Dealers/Agency Profile"
                          }
                        />
                      </div>

                      <div
                        className="page-name"
                        onClick={toggleDropdown}
                        style={{ display: "flex", alignItems: "center", gap: "6px" }}
                      >
                        <h4
                          className={
                            window.location.pathname === "/user/companyprofile"
                              ? "active"
                              : "inactive"
                          }
                          title={
                            Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                              Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                                Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                                  "Manufacturer/Dealers/Agency Profile"
                          }
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "220px",
                          }}
                        >
                          {
                            Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                              Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                                Number(detail_info?.user_type) === 3 ? "Dealers Profile" :
                                  "Manufacturer/Dealers/Agency Profile"
                          }
                        </h4>
                        <span
                          style={{
                            fontSize: "0.7em",
                            userSelect: "none",
                            display: "inline-block",
                            transition: "transform 0.3s ease",
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            marginLeft: 4,
                          }}
                        >
                          ▼
                        </span>
                      </div>
                    </div>

                    <ul
                      className={`dropdown-menu-custom ${open ? "open" : ""}`}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        maxHeight: open ? "300px" : "0",
                        opacity: open ? 1 : 0,
                        transition: "max-height 0.2s ease, opacity 0.2s ease",
                        overflow: "hidden",
                        padding: open ? "8px 0" : "0",
                        pointerEvents: open ? "auto" : "none",
                        height: open ? "auto" : "0",
                        marginBottom: open ? "10px" : "0",
                        marginLeft: window.innerWidth < 768 ? "0" : "2.5rem",
                      }}
                    >
                      <li className="enroll-dropdown-item">
                        <Link
                          to="/user/companyprofile"
                          state={{ type: "Company" }}
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => {
                            setOpen(false);
                            setEnrollOpen(false);
                          }}
                        >
                          <FaBuilding color="brown" /> {
                            Number(detail_info?.user_type) === 1 ? "Manufacturer Profile" :
                              Number(detail_info?.user_type) === 2 ? "Agency Profile" :
                                Number(detail_info?.user_type) === 3 ? "Dealer Profile" :
                                  "Enroll Now"
                          }
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center gap-2"
                          to="/user/myordersagent"
                          state={{ type: "Company" }}
                          onClick={() => setOpen(false)} // <--- close dropdown here
                        >
                          <FaListAlt color="brown" /> Orders List
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center gap-2"
                          to="/user/myordersagent"
                          state={{ type: "Products" }}
                          onClick={() => setOpen(false)} // <--- close dropdown here
                        >
                          <FaBoxOpen color="brown" /> Products List
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}


                {detail_info?.role == 1 ? (
                  <Link to="/user/commission">
                    {" "}
                    <div className="dashboard-list d-flex align-items-center gap-3">
                      <div className="page-icon">
                        <img src="\assets\iocns\agent.png" className="img-fluid" />
                      </div>
                      <div className="page-name">
                        <h4
                          className={
                            window.location.pathname === "/user/commission"
                              ? "active"
                              : "inactive"
                          }
                        >
                          Commission
                        </h4>
                      </div>
                    </div>
                  </Link>
                ) : (
                  ""
                )}


                {detail_info?.role == 1 ? (
                  <Link to="/user/payoutrequest">
                    {" "}
                    <div className="dashboard-list d-flex align-items-center gap-3">
                      <div className="page-icon">
                        <img src="\assets\iocns\agent.png" className="img-fluid" />
                      </div>
                      <div className="page-name">
                        <h4
                          className={
                            window.location.pathname === "/user/payoutrequest"
                              ? "active"
                              : "inactive"
                          }
                        >
                          Payout Request
                        </h4>
                      </div>
                    </div>
                  </Link>
                ) : (
                  ""
                )}

                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\right arrow round.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/wishlist">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/wishlist"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Wishlist
                      </h4>
                    </Link>
                  </div>
                </div>

                <Link to="/user/wallet-history">
                  {" "}
                  <div className="dashboard-list d-flex align-items-center gap-3">
                    <div className="page-icon">
                      <img src="\assets\iocns\walletHistory.png" className="img-fluid" />
                    </div>
                    <div className="page-name">
                      <h4
                        className={
                          window.location.pathname === "/user/wallet-history"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Wallet History
                      </h4>
                    </div>
                  </div>
                </Link>

                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\KYC.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/kyc">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/kyc"
                            ? "active"
                            : "inactive"
                        }
                      >
                        KYC
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\SIP.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/beneficiaries">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/beneficiaries"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Beneficiaries
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\right arrow round.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/chit-jewels">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/chit-jewels"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Chit Jewels Saving Plan
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\right arrow round.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/digital-gold">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/digital-gold"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Digital Gold Plan
                      </h4>
                    </Link>
                  </div>

                </div>

                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\right arrow round.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/digital-gold">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/digital-gold"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Digital Silver Plan
                      </h4>
                    </Link>
                  </div>

                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\right arrow round.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/gold-plant">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/gold-plant"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Gold Plant Schemes Plan
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img
                      src="\assets\iocns\notification.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="page-name">
                    <Link to="/user/Notifycation">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/Notifycation"
                            ? "active"
                            : "inactive"
                        }
                      >
                        Notification
                      </h4>
                    </Link>
                  </div>
                </div>
                <div className="dashboard-list d-flex align-items-center gap-3">
                  <div className="page-icon">
                    <img src="\assets\iocns\bank.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <Link to="/user/mybank-account">
                      {" "}
                      <h4
                        className={
                          window.location.pathname === "/user/mybank-account"
                            ? "active"
                            : "inactive"
                        }
                      >
                        My Bank Accounts
                      </h4>
                    </Link>
                  </div>
                </div>

                {/* <div
                  className="dashboard-list border-0 d-flex align-items-center gap-3"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_account_modal"
                >
                  <div className="page-icon">
                    <img src="\assets\iocns\Logout.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <h4 className="">Delete Account</h4>
                  </div>
                </div> */}

                <div
                  className="dashboard-list border-0 d-flex align-items-center gap-3"
                  data-bs-toggle="modal"
                  data-bs-target="#logout_modal"
                >
                  <div className="page-icon">
                    <img src="\assets\iocns\Logout.png" className="img-fluid" />
                  </div>
                  <div className="page-name">
                    <h4 className="active">Logout</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Logout />
      <DeleteAccount />
    </>
  );
};

export default Dashboard;
